import React, {Component} from 'react';
import {Form, actions} from 'react-redux-form';
import {connect} from 'react-redux';
import {Button,Grid,Row,Col} from 'react-bootstrap';
import RequiredPasswordMaskInput from '../../common/form/elements/required-password-mask-input'
import SecurityQuestionAnswer from '../../common/form/user/security-question-answer-input'
import PageTitle from "../../common/page-title/index";
import ArrowButton from "../../common/button-arrow";
import {updateSecurityQuestionsForAdmin} from '../../../actions/update-security-questions';
import {getQuestions} from '../../../actions/about-you'

import './update-security-questions.css'

class UpdateSecurityQuestions extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount(){
      this.props.dispatch(getQuestions());
    }

    updateErrors = (field, value) => {
        this.setState({[field]: value});
    };

    onSaveClicked = (payload) => {
        this.props.dispatch(actions.submitFields('deep.updateSecQ.user', updateSecurityQuestionsForAdmin('/admin/my-profile', payload)));
    };

    render() {
        return (
            <Form
                model="deep.updateSecQ.user"
                onSubmit={this.onSaveClicked}>
                <Grid fluid className="update-security-questions">
                    <Row>
                        <Col md={12}>
                            <PageTitle>Update security questions</PageTitle>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <RequiredPasswordMaskInput
                                model=".current_password"
                                inputType="password"
                                label="Please confirm password to make changes to security questions"
                                controlId="currentPassword"/>

                            <SecurityQuestionAnswer
                              questions={this.props.questions.filter(question => question.attributes['list-number'] === 1)}
                                questionModel=".security_answers_attributes[0].security_question_id"
                                answerModel=".security_answers_attributes[0].answer"
                                questionControlId="userSecurityQuestion1"
                                answerControlId="userSecurityAnswer1"/>

                            <SecurityQuestionAnswer
                              questions={this.props.questions.filter(question => question.attributes['list-number'] === 2)}
                              questionModel=".security_answers_attributes[1].security_question_id"
                              answerModel=".security_answers_attributes[1].answer"
                              questionLabel="Security question 2"
                              answerLabel="Security answer 2"
                              answerPlaceHolder="Security answer 2"
                              questionControlId="userSecurityQuestion2"
                              answerControlId="userSecurityAnswer2"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <ArrowButton color="red"
                                         className="pull-right"
                                         arrow={false}>Save</ArrowButton>
                        </Col>
                    </Row>
                </Grid>
            </Form>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      questions: state.aboutYou.questions,
    };
};

export default connect(mapStateToProps)(UpdateSecurityQuestions);


// WEBPACK FOOTER //
// ./src/components/admin/update-security-questions/index.jsx